import { useState } from 'react';

export const useCanvasState = () => {
  const [isDrawing, setIsDrawing] = useState(false);
  const [ctx, setCtx] = useState(null);
  const [imageUrl, setImageUrl] = useState('');
  const [brushColor, setBrushColor] = useState('#000000');
  const [brushWidth, setBrushWidth] = useState(5);
  const [history, setHistory] = useState([]);
  const [scale, setScale] = useState(1);
  const [imageWidth, setImageWidth] = useState(0);
  const [imageHeight, setImageHeight] = useState(0);
  const [canvasText, setCanvasText] = useState('');
  const [showCanvasText, setShowCanvasText] = useState(false);
  const [isTextRegim, setIsTextRegim] = useState(false);
  const [xY, setXY] = useState({ offsetX: 0, offsetY: 0 });
  const [canvasFont, setCanvasFont] = useState(26);
  const [isSaving, setIsSaving] = useState(false);
  const [loading, setLoading] = useState(false);
  const [changeImage, setChangeImage] = useState(false);

  return {
    changeImage, setChangeImage,
    isDrawing, setIsDrawing,
    ctx, setCtx,
    imageUrl, setImageUrl,
    brushColor, setBrushColor,
    brushWidth, setBrushWidth,
    history, setHistory,
    scale, setScale,
    imageWidth, setImageWidth,
    imageHeight, setImageHeight,
    canvasText, setCanvasText,
    showCanvasText, setShowCanvasText,
    isTextRegim, setIsTextRegim,
    xY, setXY,
    canvasFont, setCanvasFont,
    isSaving, setIsSaving,
    loading, setLoading
  };
};